import $ from 'jquery';


export class Form {
    constructor() {

        /***********************************************************************************************
        * PROJECT FORM
        */
        if($("#form_1").get(0) != undefined){
            $("#logotype").click(function(){
                $(".file-uploaded-info").empty();
            });

            let danger_switches = $(".form-switch").find("input");
            var last_el;
            //let checked_danger_switches = $(".form-switch").find("input:checked");
            //console.log(checked_danger_switches);
            danger_switches.on("change", function(){
                if($(this).is(":not(:checked)")){

                    last_el = $(this);
                    // display modal
                    let modal_danger_alert = new bootstrap.Modal(document.getElementById('modal-dialog-danger-alert'), "show");
                    modal_danger_alert.show();

                    // checked back
                    $("#danger-alert-cancel").on("click", function(){
                        //console.log(last_el);
                        last_el.prop('checked',true);
                    });
                }
            });

        }
        /***********************************************************************************************
        * ￼MEASURES FORM
        */
        if($("#form_2 #type").get(0) != undefined){
            var type = $("#type");
            let type_select = type.find("select");
            let type_value = type.find(":selected").val();
            let mode = $("#mode").find("input");
            let autoload_fields = mode.attr("data-auto-fields");
            let mode_value = mode.is(":checked");
            let invest_cost = $("#invest_cost").find("input");

            console.log(mode_value);
            //console.log(autoload_fields);
            //console.log(mode_value);
            //console.log(autoload_fields);

            if(['maintenance_of_the_protective_forest', 'measurements_to_object', 'other'].includes(type_value)){
                mode.prop('checked',true);
                mode.attr('disabled', 'disabled');
                mode_value = mode.is(":checked");
                //autoloadMesureValues(mode_value, type_value, autoload_fields);
            }
            if(['combination_of_measures'].includes(type_value)){
                mode.prop('checked',false);
                mode.attr('disabled', 'disabled');
                mode_value = mode.is(":checked");
                $("#invest_cost").find("input").attr("readonly", "readonly").addClass("form-control-plaintext");
                //autoloadMesureValues(mode_value, type_value, autoload_fields);
            }
            autoloadMesureValues(mode_value, type_value, autoload_fields);

            type_select.on("change", function(){
                var type_value = type.find(":selected").val();
                if(['maintenance_of_the_protective_forest', 'measurements_to_object', 'other'].includes(type_value)){
                    mode.prop('checked',true);
                    mode.attr('disabled', 'disabled');
                    mode_value = mode.is(":checked");
                }else if(['combination_of_measures'].includes(type_value)){
                    mode.prop('checked',false);
                    mode.attr('disabled', 'disabled');
                    mode_value = mode.is(":checked");
                    $("#invest_cost").find("input").attr("readonly", "readonly").addClass("form-control-plaintext");
                    console.log($("#invest_cost").find("input"));
                    //autoloadMesureValues(mode_value, type_value, autoload_fields);
                }else{
                    mode.prop('checked',false);
                    mode.removeAttr('disabled');
                    mode_value = mode.is(":checked");
                    $("#invest_cost").find("input").removeAttr("readonly").removeClass("form-control-plaintext");

                }
                autoloadMesureValues(mode_value, type_value, autoload_fields);
            });

            mode.on("click", function(){
                mode_value = mode.is(":checked");
                type_value = type.find(":selected").val();
                autoloadMesureValues(mode_value, type_value, autoload_fields);
            });

            $("#values_measures").find("input").on("keyup", function(){
                type_value = type.find(":selected").val();
                autoloadMesureValues(mode_value, type_value, autoload_fields);
            });

        }


        /***********************************************************************************************
        * OBJECTS FORM
        */
        if($("#form_3 #category").get(0) != undefined){
            let category = $("#category");
            let category_select = category.find("select");
            let type = $("#type");
            let type_select = type.find("select");
            let modes = $(".mode").find("input");
            var type_value = $("#type").find(":selected").val();
            let data_condition = category.find(".form-select").attr("data-condition");
            var category_value = category.find(":selected").val();
            var nbr_object = $("#nbr_object").find("input");

            populateTypeOptions();

            category_select.on("change", function(){
                populateTypeOptions();
            });

            type_select.on("change", function(){
                type_value = type.find(":selected").val();
            });

            if(data_condition != undefined && data_condition != ""){
                let obj = $.parseJSON(data_condition);
                $.each(obj, function(cat_id, value){
                    //alert(cat_id + ": " + value );
                    let $div = $(value);
                    if(category_value == cat_id){
                        $div.removeClass("disabled-section");
                        $div.find("input").removeAttr('disabled');
                    }

                    category.on("change", function (event){
                        category_value = category.find(":selected").val();

                        // Display section
                        if(category_value == cat_id){
                            //console.log($div);
                            $(".condition-section:not("+value+")").addClass("disabled-section");
                            $(".condition-section:not("+value+")").find("input").attr('disabled','disabled');
                            $div.removeClass("disabled-section");
                            $div.find("input").removeAttr('disabled');
                        }
                    });
                });
            }
            setTimeout(function(){
                //console.log(category_value);
                //console.log(type_value);
                type_value = type.find(":selected").val();
                findCheckboxesAndLoadValues(category_value, type_value);
            },4000);

            type.on("change", function (event){
                console.log(category_value);
                let type_value = type.find(":selected").val();
                getCostUnit(category_value, type_value);
                findCheckboxesAndLoadValues(category_value, type_value);
            });

            nbr_object.on("change", function(){
                findCheckboxesAndLoadValues(category_value, type_value);
            });
        }

        /***********************************************************************************************
        * INTENSITY FORM
        */
        if($("#form_4").get(0) != undefined){
            findCheckboxesAndLoadValues();

            // Calculate composite total fields
            // $total_composite_field = $(".t_section").find(".t_composite_total");
            // $total_composite_field.each(function(){
            //     calculate_composite_total();
            // });

            $(".t_composite").on("keyup change", function(){
                calculate_composite_total($(this));
                // var total = 0;
                // $(this).parents(".t_section").find(".t_composite:not(.t_composite_total)").each(function(){
                //     total += parseInt($(this).val());
                // });
                // $(this).parents(".t_section").find(".t_composite_total").val(total);
            });

            $(".readonly").keydown(function(e){
                e.preventDefault();
            });

            enableFrequFields_global();
            $(".toggle_switch").on("click", function(){
                enableFrequFields_global();
            });
            // // Switch init
            // let $toggle_switch = $(".toggle_switch");
            // //console.log($toggle_switch);
            // $toggle_switch.each(function(){
            //     let switch_value = $(this).is(":checked");
            //     let switch_id = $(this).attr("id");
            //     let switch_attr_data_enable_fields = $(this).attr("data-enable-fields");
            //     let switch_attr_data_disable_fields = $(this).attr("data-disable-fields");
            //     enableFrequFields(switch_value, switch_id, switch_attr_data_enable_fields, switch_attr_data_disable_fields);
            // });
            //
            // //console.log(scenarios);
            // // Switch on click
            // $(".toggle_switch").on("click", function(){
            //     let switch_value = $(this).is(":checked");
            //     let switch_id = $(this).attr("id");
            //     let switch_attr_data_enable_fields = $(this).attr("data-enable-fields");
            //     let switch_attr_data_disable_fields = $(this).attr("data-disable-fields");
            //
            //     if($(this).is(":checked")){
            //         switch_value = true;
            //     }else{
            //         switch_value = false;
            //     }
            //
            //     enableFrequFields(switch_value, switch_id, switch_attr_data_enable_fields, switch_attr_data_disable_fields);
            // });
        }



        /***********************************************************************************************
        * ￼Form soumission
        */
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.querySelectorAll('.needs-validation');

        if(forms.length == 1){
            // TO UNCOMMENT Alert on form unload
            //alertOnBeforeUnload();

            //￼Submit form on tab and menu click => saved data
            $(".submit_ajax_form").on("click", function(event){
                event.preventDefault();
                document.querySelector("form").requestSubmit();
            });
        }

        // Loop over them and prevent submission
        Array.prototype.slice.call(forms)
        .forEach(function (form) {
          form.addEventListener('submit', function (event) {
              // Min 1 danger checked
              if($("#custom_switch_val").get(0) != undefined){
                  let $checked_switches = $("#custom_switch_val").find($("input:checked")).length;
                  $("#switches_validation").val($checked_switches);
              }
              event.preventDefault();
          // Validation
          if (!form.checkValidity()) {
              event.stopPropagation();
              let header_offset = $(".sticky-top").innerHeight();
              let top_position = $(":invalid").eq(1).offset().top-header_offset;
              $('html, body').animate({
                  scrollTop: top_position
              }, "fast");
              //console.log(top_position);
          // AJAX
          }else{
              var formData = new FormData($("form")[0]);
              $('.form-check-input:not(:checked)[type="checkbox"]').each(function( index ) {
                formData.append($(this).attr("name"), false);
              });

              console.log(formData);
              $.ajax({
                  url : ajaxurlobject,
                  type : "POST",
                  data : formData,
                  contentType: false,
                  processData: false,
                  success: function(response){
                     console.log('The server responded: ', response);
                     let redirect = $(".ajax_button:focus").attr("data-redirect");
                     if(redirect == undefined){
                         redirect = $(".submit_ajax_form:focus").attr("href");
                     }
                     if(redirect == "scroll-up"){
                        let parsed_response = JSON.parse(response);
                        $("#main-menu-ajax-wrapper").html(parsed_response.main_menu);
                        if($("#sub-menu-ajax-wrapper").get(0) != undefined){
                            $("#sub-menu-ajax-wrapper").html(parsed_response.sub_menu);
                        }
                        //$("#main-menu-wrapper").append(response["main_menu"]);
                        $('html,body').animate({
                 	    	scrollTop : 0
                 	    },'fast');
                     }else{
                         window.location.href = redirect;
                     }
                 }
              });
          }
            form.classList.add('was-validated');
          }, false)
        })

        delete_element();

    }
}

/***********************************************************************************************
* MEASURES and OBJECTS
* Ajax Function getCostUnit()￼
* @return {redirection} redirect to summary
*/
function delete_element(){
    $(".ajax_delete").on("click", function(){
        let type = $(this).attr("data-type");
        let id = $(this).attr("data-id");
        let nonce = $(this).attr("data-nonce");
        $.post(
            ajaxurlobject,
            {
                'action': 'delete_element',
                'id': id,
                'type': type,
                '_wpnonce' : nonce,
            },
            function(response){
                window.location.href = $(".ajax_delete").attr("data-redirect");
            }
        );
    });
}

/***********************************************************************************************
* MEASURES
* Ajax Function getCostUnit()
* @param  {text}    category_value  selected category value
* @param  {int}     type_value      selected type value
* @return {html}                    load cost value
*/
function getCostUnit(category_value, type_value){
    if(category_value != "" && type_value != ""){
        $.post(
            ajaxurlobject,
            {
                'action': 'get_cost_unit',
                'category' : category_value,
                'sub_category' : type_value,
                //'_wpnonce' : nonce,
            },
            function(values){
                let data = $.parseJSON(values);
                //let $input = $("#cost .unit");
                $("#cost .unit").text(data.cost_unit);
                $("#nbr_object .unit").text(data.unit);

            }
        );
    }
}

/***********************************************************************************************
* OBJECT abd INTENSITY
* Ajax Function findCheckboxesAndLoadValues()
* @param  {text}    category_value  selected category value
* @param  {int}     type_value      selected type value
* @return {html}                    load values
*/
function findCheckboxesAndLoadValues(category_value = false, type_value = false){
    //console.log(category_value);
    //console.log(type_value);
    if((category_value != "" && type_value != "" && category_value != false && type_value != false) || $("#form_4").get(0) != undefined){
        $(".form-check").each(function( index ) {

            //console.log($(this));

            // If section is disabled => do nothing
            if($(this).parents(".condition-section").hasClass("disabled-section")){
                //console.log($(this).parents(".condition-section"));
            }else{
                let mode = $(this).find("input");
                let mode_value = mode.is(":checked");
                let mode_attr_data_auto_fields = mode.attr("data-auto-fields");
                if(mode_attr_data_auto_fields != false && mode_attr_data_auto_fields != undefined){
                    let autoload_fields = mode.attr("data-auto-fields");
                    autoloadObjectAndIntensityValues(mode_value, category_value, type_value, autoload_fields);

                    mode.on("click", function(){
                        if(mode_value == true){
                            mode_value = false;
                        }else{
                            mode_value = true;
                        }
                        autoloadObjectAndIntensityValues(mode_value, category_value, type_value, autoload_fields);
                    });
                }
            }
        });
    }
}

/***********************************************************************************************
* MEASURES
* Ajax Function calcAnnualCost()
* @return {html}    load values
*/
function calcAnnualCost(category){
        //console.log("calc");
        let invest_cost_value = $("#invest_cost").find("input").val();
        let exploitation_cost_value = $("#exploitation_cost").find("input").val();
        let maintenance_cost_value = $("#maintenance_cost").find("input").val();
        let repair_cost_value = $("#repair_cost").find("input").val();
        let residual_value_value = $("#residual_value").find("input").val();
        let effective_period_value = $("#effective_period").find("input").val();
        let interest_rate_value = $("#interest_rate").find("input").val();
        $.post(
            ajaxurlobject,
            {
                'action': 'calc_annual_cost',
                'category' : category,
                'invest_cost' : invest_cost_value,
                'exploitation_cost' : exploitation_cost_value,
                'maintenance_cost' : maintenance_cost_value,
                'repair_cost' : repair_cost_value,
                'residual_value' : residual_value_value,
                'effective_period' : effective_period_value,
                'interest_rate' : interest_rate_value,
                //'_wpnonce' : nonce,
            },
            function(value){
                //console.log(value);
                if(value != ""){
                    $("#annual_costs").find("input").val(value);
                }

            }
        );
}

/***********************************************************************************************
* MEASURES
* Ajax Function autoloadMesureValues()
* @param  {bool}    mode_value          controller value
* @param  {int}    category            selected type value
* @param  {text}   autoload_fields     controlled fields
* @return {html}                        load values
*/
function autoloadMesureValues(mode_value, category, autoload_fields){
    if(category != ""){
        if(mode_value == false){
            console.log("off");
            let invest_cost_value = $("#invest_cost").find("input").val();
            //console.log(invest_cost_value);
            $.post(
                ajaxurlobject,
                {
                    'action': 'autoload_mesure_values',
                    'category' : category,
                    'autoload_fields' : autoload_fields,
                    'invest_cost' : invest_cost_value
                    //'_wpnonce' : nonce,
                },
                function(values){
                    console.log(values);
                    let data = $.parseJSON(values);
                    $.each(data, function(key,value) {
                        let $input = $("#"+key).find("input");
                        $input.attr("readonly", "readonly");
                        $input.addClass("form-control-plaintext");
                        $input.val(value);
                    });
                    calcAnnualCost(category);
                }
            );
        }else{
            console.log("on");
            let data = autoload_fields.split(",");
            $.each(data, function(key,value) {
                let $input = $("#"+value).find("input");
                $input.removeAttr("readonly");
                $input.removeClass("form-control-plaintext");
            });
            calcAnnualCost(category);
        }
    }
}

/***********************************************************************************************
* ￼INTENSITY
* Function calculate_composite_total()
*/
function calculate_composite_total(item){
    var total = 0;
    item.parents(".t_section").find(".t_composite:not(.t_composite_total)").each(function(){
        total += parseInt($(this).val());
    });
    item.parents(".t_section").find(".t_composite_total").val(total);
}

/***********************************************************************************************
* INTENSITY
* Function enableFrequFields_global()
* @param  {bool}    mode_value        controller value
* @param  {text}    scenario_id       selected type value
* @param  {text}   enable_fields     controlled fields
* @param  {text}   disable_fields     controlled fields
* @return {html}                     load values
*/
function enableFrequFields_global(){
    let $toggle_switch = $(".toggle_switch");
    let switch_array = [];
    //console.log($toggle_switch);

    // Find switch values
    $toggle_switch.each(function(counter){
        let switch_id = $(this).attr("id");
        let switch_key = $(this).attr("data-key");
        let enable_fields = $(this).attr("data-enable-fields");
        let data_enable_fields = enable_fields.split(",")

        switch_array[switch_key] = [];
        switch_array[switch_key]["id"] = switch_id;
        switch_array[switch_key]["value"] = $(this).is(":checked");
        switch_array[switch_key]["data_enable_fields"] = data_enable_fields;

        $.each(data_enable_fields, function(key,value) {
            let $section = $("."+value);

            // Disabled section and input
            $section.addClass("disabled-section");
            $section.find("input").attr('disabled','disabled');
            $section.find("select").attr('disabled','disabled');
        });
    });


    // COMOMON SCENARIO
    if(switch_array.common_scenario != undefined && switch_array.common_scenario.value === true){
        //console.log(1);
        let $input = $("#"+switch_array.common_scenario.id+"_t");
        let data_enable_fields = switch_array.common_scenario.data_enable_fields;
        $input.removeAttr("readonly");
        $input.removeClass("form-control-plaintext");

        $.each(data_enable_fields, function(key,value) {
            let $section = $("."+value);

            // Activate fields only if section not disabled
            if($section.parents(".t_section").hasClass("disabled-section") === false){
                // enabled section and input
                $section.removeClass("disabled-section");
                $section.find("input:not(.t_composite)").removeAttr('disabled');
                $section.find("select").removeAttr('disabled');
            }
        });
    }

    // EXTREME SCENARIO
    if(switch_array.extreme_scenario != undefined && switch_array.extreme_scenario.value === true){
        //console.log(2);
        let $input = $("#"+switch_array.extreme_scenario.id+"_t");
        let data_enable_fields = switch_array.extreme_scenario.data_enable_fields;
        $input.removeAttr("readonly");
        $input.removeClass("form-control-plaintext");

        $.each(data_enable_fields, function(key,value) {
            let $section = $("."+value);

            // Activate fields only if section not disabled
            if($section.parents(".t_section").hasClass("disabled-section") === false){
                // enabled section and input
                $section.removeClass("disabled-section");
                $section.find("input:not(.t_composite)").removeAttr('disabled');
                $section.find("select").removeAttr('disabled');
            }
        });
    }

    // COMPOSITE CALC ON
    if(switch_array.composite_calc != undefined && switch_array.composite_calc.value === true){
        //console.log(3);
        let data_enable_fields = switch_array.composite_calc.data_enable_fields;

        if(switch_array.common_scenario != undefined && switch_array.common_scenario.value === false ){
            let index = data_enable_fields.indexOf("t_freq_composite");
            data_enable_fields.splice(index, 1);
            //data_enable_fields.push("t_freq_composite");
        }

        if(switch_array.extreme_scenario != undefined && switch_array.extreme_scenario.value === false){
            let index = data_enable_fields.indexOf("t_ex_composite");
            data_enable_fields.splice(index, 1);
            //data_enable_fields.push("t_ex_composite");
        }

        //Disabled intensity field
        $(".intensity_field").addClass("disabled-section");
        $(".intensity_field").find("select").attr('disabled','disabled');

        $.each(data_enable_fields, function(key,value) {
            let $section = $("."+value);

            // enabled section and input
            $section.removeClass("disabled-section");
            $section.find("input").removeAttr('disabled');
            $section.find("select").removeAttr('disabled');
        });

    // COMPOSITE CALC OFF
    }else{
        //console.log(4);

        //Enable all intensity field
        $(".intensity_field").removeClass("disabled-section");
        $(".intensity_field").find("select").removeAttr('disabled');

        // Disable not wanted
        if(switch_array.common_scenario != undefined && switch_array.common_scenario.value === false){
            //console.log(5);
            let $input = $("#"+switch_array.common_scenario.id+"_t");
            $input.attr("readonly", "readonly");
            $input.addClass("form-control-plaintext");
            $(".t_section.t_freq .intensity_field").addClass("disabled-section");
            $(".t_section.t_freq .intensity_field").find("select").attr('disabled','disabled');
        }
        if(switch_array.extreme_scenario != undefined && switch_array.extreme_scenario.value === false){
            //console.log(6);
            let $input = $("#"+switch_array.extreme_scenario.id+"_t");
            $input.attr("readonly", "readonly");
            $input.addClass("form-control-plaintext");
            //$("#"+switch_array.extreme_scenario.id+"_t").attr('disabled','disabled');
            $(".t_section.t_ex .intensity_field").addClass("disabled-section");
            $(".t_section.t_ex .intensity_field").find("select").attr('disabled','disabled');

        }

    }
}

/***********************************************************************************************
* INTENSITY
* Function enableFrequFields()
* @param  {bool}    mode_value        controller value
* @param  {text}    scenario_id       selected type value
* @param  {text}   enable_fields     controlled fields
* @param  {text}   disable_fields     controlled fields
* @return {html}                     load values
*/
function enableFrequFields(mode_value, switch_id, enable_fields, disable_fields){
    let data = enable_fields.split(",");
    let $switch = $("#"+switch_id);
    let $input = $("#"+switch_id+"_t");
    var is_composite_calc_switch = $switch.hasClass("composite_calc");

    if(mode_value == false){
        console.log("off");

        $input.attr("readonly", "readonly");
        $input.addClass("form-control-plaintext");

        // Enable fields
        //console.log(disable_fields+"disable_fields");
        console.log($("."+disable_fields).parent(".t_section"));
        if(disable_fields != undefined && $("."+disable_fields).parent(".t_section").hasClass(".disabled-section") === false){
            console.log("disable_fields: "+disable_fields);
            console.log($("."+disable_fields).parent(".t_section").hasClass(".disabled-section"));
            $("."+disable_fields).removeClass("disabled-section");
            $("."+disable_fields).find("select").removeAttr('disabled');
        }

        $.each(data, function(key,value) {
            console.log(value);
            let $section = $("."+value);

            // Clear composite value
            if(is_composite_calc_switch){
                $section.find("input").val("");
            }

            // Disabled section and input
            $section.addClass("disabled-section");
            $section.find("input").attr('disabled','disabled');
            $section.find("select").attr('disabled','disabled');

        });
    }else{
        console.log("on");

        $input.removeAttr("readonly");
        $input.removeClass("form-control-plaintext");

        // Disabled field
        if(disable_fields != undefined){
            $("."+disable_fields).addClass("disabled-section");
            $("."+disable_fields).find("select").attr('disabled','disabled');
        }

        $.each(data, function(key,value) {
            let $section = $("."+value);

            // Activate fields only if section not disabled
            if($section.parents(".t_section").hasClass("disabled-section") == false){
                // enabled section and input
                $section.removeClass("disabled-section");
                $section.find("input").removeAttr('disabled');
                $section.find("select").removeAttr('disabled');
            }


        });
    }
}

/***********************************************************************************************
* OBJECT and INTENSITY
* Ajax Function autoloadObjectAndIntensityValues()
* @param  {bool}   mode_value       controller value
* @param  {text}   category         selected type value
* @param  {int}    sub_category     selected type value
* @param  {text}   enable_fields    controlled fields
* @return {html}                    load values
*/
function autoloadObjectAndIntensityValues(mode_value, category = false, sub_category = false, autoload_fields){

    if(mode_value == false){
        console.log("mode manuel off");
        var fields_id = [];
        let autoload_fields_array = autoload_fields.split(",");
        //console.log(autoload_fields_array);
        // console.log(category);
        // console.log(sub_category);
        $.each(autoload_fields_array, function(key,value) {
            //console.log(value);
            let $inputs = $("."+value).find("input");
            //console.log($inputs);
            let $inputs_auto_field = $("."+value).find("input.auto_field");
            //console.log($inputs_auto_field);
            length = $inputs.length;
            $inputs_auto_field.each(function(index) {
                //console.log(length);
                if(length > 1){
                    fields_id[value+"_"+index] = $(this).attr("id");
                }else{
                    fields_id[value] = $(this).attr("id");
                }
            });
            //console.log(fields_id);
        });

        $.post(
            ajaxurlobject,
            {
                'action': 'autoload_object_and_intensity_values',
                'category' : category,
                'sub_category' : sub_category,
                'autoload_fields' : JSON.stringify(Object.assign({}, fields_id)),
                'nbr_objects' : $("#nbr_object").find("input").val()
                //'_wpnonce' : nonce,
            },
            function(values){
                console.log(values);
                let data = $.parseJSON(values);
                $.each(data, function(key,value) {
                    let $input = $(":not(.disabled-section) #"+key);
                    console.log($input);
                    $input.attr("readonly", "readonly");
                    $input.addClass("form-control-plaintext").val(value);
                });
            }
        );
    }else{
        //console.log("mode manuel on");
        let data = autoload_fields.split(",");
        //console.log(data);
        $.each(data, function(key,value) {
            let $input = $("."+value).find("input");
            $input.removeAttr("readonly");
            $input.removeClass("form-control-plaintext");
        });
    }
}

/***********************************************************************************************
* OBJECT
* Ajax Function populateTypeOptions()
* Dynamic select list according to parent + conditions
* @return {html}  load values
*/
function populateTypeOptions(){
    let category = $("#category");
    let type = $("#type");
    let type_select = type.find("select");
    let type_select_path = type_select.attr("id");
    let category_value = category.find(":selected").val();
    //let type_value = type.find(":selected").val();
    //console.log(type_value);
    if(category_value != ""){
        //console.log(category_value);
        let nonce = type_select.attr("data-nonce");
        $.post(
            ajaxurlobject,
            {
                'action': 'populate_type_options',
                'category': category_value,
                // 'type' : type_value,
                'type_path': type_select_path,
                '_wpnonce' : nonce,
            },
            function(response){
                //console.log(response);
                let json = JSON.parse(response);
                type_select.html(json.options_html);
                //type_select.html(response);
            }
        );
    }
}

/***********************************************************************************************
* GLOBAL
* Function alertOnBeforeUnload()
* Alert on browser tab closed
*/
function alertOnBeforeUnload(event) {

    window.onbeforeunload = () => true;
    document.querySelectorAll("a, button")
        .forEach((element) =>
            element.addEventListener(
                "click",
                () => (window.onbeforeunload = null)
            )
    );

};

/***********************************************************************************************
* ￼setRequired
*/
// function setRequired(val){
//     input = document.getElementById("show").getElementsByTagName('input');
//     for(i = 0; i < input.length; i++){
//         input[i].required = val;
//     }
// }
/***********************************************************************************************
* ￼Override the jquery.serialize() method to send both checked/unchecked values
*/
// var originalSerializeArray = $.fn.serializeArray;
// $.fn.extend({
//     serializeArray: function () {
//         var brokenSerialization = originalSerializeArray.apply(this);
//         var checkboxValues = $(this).find('input[type=checkbox]').map(function () {
//             return { 'name': this.name, 'value': this.checked };
//         }).get();
//         var checkboxKeys = $.map(checkboxValues, function (element) { return element.name; });
//         var withoutCheckboxes = $.grep(brokenSerialization, function (element) {
//             return $.inArray(element.name, checkboxKeys) == -1;
//         });
//
//         return $.merge(withoutCheckboxes, checkboxValues);
//     }
// });
